import React, { useRef, useState, useContext, useEffect, useCallback } from 'react';
import { classNames } from 'primereact/utils';
import { InputText } from 'primereact/inputtext';
import { useHistory, useLocation } from "react-router-dom"; // Importado useLocation
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { Skeleton } from 'primereact/skeleton';
import { BrCalendar } from './BrCalendar';
import { useFormik } from 'formik';
import * as Yup from 'yup';

import { ErrorValidationMessage } from './ErrorValidationMessage';

import { AuthContext } from '../contexts/AuthContext'

import api from '../api/api';

import '../layout/sass/_form.scss';
import { Dropdown } from 'primereact/dropdown';
import { TabelaAlunosFalta } from './TabelaAlunosFalta';

export const FormFalta = ({ isEditing, isLoading, defaultValues }) => {

    const location = useLocation(); // Captura o estado da navegação
    const history = useHistory();
    const toast = useRef(null);

    // Captura o ID fixo vindo da navegação para a nova lógica
    const [turmaIdObrigatorio] = useState(location.state?.turmaId);

    const [turma, setTurma] = useState("");
    const [isSubmiting, setIsSubmiting] = useState(false)
    const { user } = useContext(AuthContext);
    const [alunos, setAlunos] = useState([])

    const schema = Yup.object().shape({
        turmaId: Yup
            .number()
            .positive("O aluno deve ser selecionado")
            .integer("O aluno deve estar na lista"),
        obs: Yup
            .string(),
        atraso: Yup // <<< ADICIONADO PARA VALIDAÇÃO
            .boolean(),
        dataOcorrencia: Yup
            .date()
            // .max(new Date(), "Data inicio inválida")
            .typeError("Uma data deve ser inserida")
            .required("A data de inicio é obrigatória")
    })

    const formik = useFormik({
        initialValues: defaultValues,
        validationSchema: schema,
        enableReinitialize: true,
        onSubmit: async (data) => {
            setIsSubmiting(true);

            try {
                // Tenta capturar o ID da turma de todas as fontes possíveis
                const idRetorno = turmaIdObrigatorio ||
                    data.turmaId ||
                    defaultValues?.turmaId ||
                    defaultValues?.turma?.id;

                if (!isEditing) {
                    // --- Lógica para CRIAR novas faltas ---
                    await Promise.all(alunos.map(async item => {
                        // 1. Só processa se houver falta/atraso e se NÃO existir um ID de falta prévio no banco
                        if ((item.presente === false || item.atrasado === true) && !item.faltaExistenteId) {

                            // 2. Verificação de segurança para o ID do aluno (usado na licença)
                            if (!item.alunoId) {
                                console.error(`Aluno ID não encontrado para matrícula ${item.matriculaId}`);
                                const dataFallback = {
                                    matriculaId: item.matriculaId, // Corrigido para usar matriculaId
                                    dataOcorrencia: data.dataOcorrencia.toISOString().split('T')[0],
                                    obs: data.obs,
                                    atraso: item.atrasado || false
                                };
                                await api.post("falta", dataFallback);
                                return;
                            }

                            try {
                                // 3. Lógica de Verificação de Licença
                                const response = await api.get(`licenca/porAluno/${item.alunoId}`);
                                let licencaAtiva = false;
                                const dataOcorrenciaFalta = new Date(data.dataOcorrencia);
                                dataOcorrenciaFalta.setHours(0, 0, 0, 0);

                                if (response.data && response.data.length > 0) {
                                    response.data.forEach(licenca => {
                                        const dataInicioLicenca = new Date(licenca.dataInicio);
                                        const dataFimLicenca = new Date(licenca.dataFim);
                                        dataInicioLicenca.setHours(0, 0, 0, 0);
                                        dataFimLicenca.setHours(23, 59, 59, 999);

                                        if (dataOcorrenciaFalta >= dataInicioLicenca && dataOcorrenciaFalta <= dataFimLicenca) {
                                            licencaAtiva = true;
                                        }
                                    });
                                }

                                // 4. Salva a nova falta apenas se não houver licença impeditiva
                                if (licencaAtiva && item.presente === false) {
                                    toast.current.show({ life: 4000, severity: 'error', summary: 'Aluno de Licença!', detail: `O aluno(a) ${item.matriculaNome} está de licença!` });
                                } else {
                                    const dataSave = {
                                        matriculaId: item.matriculaId, // ID correto da matrícula vindo do mapeamento
                                        dataOcorrencia: data.dataOcorrencia.toISOString().split('T')[0],
                                        obs: data.obs,
                                        atraso: item.atrasado || false
                                    };
                                    await api.post("falta", dataSave);
                                    toast.current.show({ life: 1500, severity: 'success', summary: item.atrasado ? 'Atraso Registrado' : 'Falta Registrada', detail: `Aluno(a) ${item.matriculaNome}` });
                                }
                            } catch (licencaError) {
                                toast.current.show({ life: 4000, severity: 'error', summary: 'Erro Verif. Licença', detail: `Não foi possível verificar licença para ${item.matriculaNome}.` });
                            }
                        }
                    }));
                    formik.resetForm();
                    setAlunos([]);
                    await setMatriculaDesistente();

                    setTimeout(() => {
                        if (idRetorno) history.push(`/turmas/edit/${idRetorno}`);
                    }, 2000);

                } else {
                    // --- Lógica para EDITAR uma falta existente ---
                    const dataEdit = {
                        ...data,
                        turmaId: idRetorno,
                        dataOcorrencia: data.dataOcorrencia instanceof Date
                            ? data.dataOcorrencia.toISOString().split('T')[0]
                            : data.dataOcorrencia,
                        atraso: data.atraso
                    };

                    await api.put("falta", dataEdit);
                    toast.current.show({ life: 2000, severity: 'success', summary: 'Cadastro atualizado!', detail: `Falta atualizada com sucesso` });

                    setTimeout(() => {
                        if (idRetorno) {
                            history.push(`/turmas/edit/${idRetorno}`);
                        } else {
                            history.goBack();
                        }
                    }, 2000);
                }
            } catch (error) {
                console.error(`Erro geral:`, error);
                toast.current.show({ life: 5000, severity: 'error', summary: `Erro na operação!`, detail: error.toString() });
            } finally {
                setIsSubmiting(false);
            }
        },
    });

    const isFormFieldValid = (name) =>
        !!(formik.touched[name] && formik.errors[name]);

    const getTurma = useCallback(async () => {
        try {
            if (user.perfilUser[0] !== 'user-instrutor') {
            if (!turmaIdObrigatorio) return;

            const response = await api.get(`turma/${turmaIdObrigatorio}`);
            const turma = response.data;

            setTurma([
                {
                    label:
                        turma.perfilNome +
                        ' - ' +
                        turma.cursoNome +
                        ' - ' +
                        turma.diaSemana +
                        '  ' +
                        turma.hora,
                    value: turma.id,
                },
            ]);
            } else {
                const response = await api.get(
                    `turma/turmaAllAtualInstrutor/${user.email}`
                );
                setTurma(
                    response.data.map((turma) => {
                        var turm = { label: '', value: '' };
                        turm.label =
                            turma.perfilNome +
                            ' - ' +
                            turma.cursoNome +
                            ' - ' +
                            turma.diaSemana +
                            '  ' +
                            turma.hora;
                        turm.value = turma.id;
                        return turm;
                    })
                );
            }
        } catch (error) {
            toast.current.show({
                severity: 'error',
                summary: 'Erro ao obter matrícula',
                detail: error.toString(),
            });
        }
    }, [user.perfilUser, user.email]);

    const setMatriculaDesistente = async () => {
        try {
            const response = await api.get(`falta/faltasSeguidas`);
            response.data.map(async (i) => {
                if (i.datasOcorrencias.length > 30) {
                    await api.post(`matricula/alteraStatus/${i.matriculaId}`, '3');
                }
            });
        } catch (error) {
            toast.current.show({
                severity: 'error',
                summary: 'Erro ao obter matrícula',
                detail: error.toString(),
            });
        }
    };

    const carregarAlunosDaTurma = useCallback(async (id, dataOcorrencia) => {
        try {
            const idNumerico = Number(id);
            if (!idNumerico || !dataOcorrencia) return;

            const dataStr = dataOcorrencia instanceof Date 
                ? dataOcorrencia.toISOString().split('T')[0] 
                : dataOcorrencia;

            const response = await api.get(`falta/verificarPresenca?turmaId=${idNumerico}&data=${dataStr}`);

            

            const itens = response.data.map(item => ({
                matriculaId: item.matriculaId, // ID da Matrícula (para o POST)
                matriculaNome: item.matriculaAlunoNome, 
                nomeSocialAluno: item.nomeSocialAluno,               
                alunoId: item.alunoId,
                presente: item.presente,
                atrasado: item.atraso,
                obs: item.obs || '',
                faltaExistenteId: item.id // ID da Falta (para controle de duplicidade)
            }));

            setAlunos(itens);
        } catch (error) {
            console.error("Erro ao carregar lista:", error);
        }
    }, []);

    useEffect(() => {
        let montado = true;
        const inicializar = async () => {
            await getTurma();
            
            // Se a turma é obrigatória, garantimos que ela esteja no Formik e carregamos os alunos
            if (turmaIdObrigatorio && !isEditing) {
                if (montado) {
                    formik.setFieldValue("turmaId", turmaIdObrigatorio);
                    // Chama a nova busca inteligente passando a data atual
                    await carregarAlunosDaTurma(turmaIdObrigatorio, formik.values.dataOcorrencia);
                }
            }
        };
        inicializar();
        return () => { montado = false; };
    }, [turmaIdObrigatorio, getTurma, carregarAlunosDaTurma, isEditing]); // Removido alunos.length para evitar conflitos

    useEffect(() => {
        // Pegamos os valores atuais do formik
        const { turmaId, dataOcorrencia } = formik.values;

        if (turmaId && dataOcorrencia) {
            carregarAlunosDaTurma(turmaId, dataOcorrencia);
        }
    }, [formik.values.dataOcorrencia, formik.values.turmaId, carregarAlunosDaTurma]);

    return (
        <>
            <div className="card p-grid p-col-12 p-mx-0 p-mt-0">
                <Toast ref={toast} position="bottom-right" />
                <div className="p-col-12">
                    <h2 className="p-mt-0">Falta</h2>
                    <form onSubmit={formik.handleSubmit}>
                        <div className="p-formgrid p-grid p-fluid p-mx-0">
                            {!isEditing ? (
                                <div className="p-field p-col-12 p-sm-4">
                                    <label
                                        htmlFor="turmaId"
                                        className={classNames({ 'p-error': isFormFieldValid('turmaId') })}
                                    >
                                        Turma
                                    </label>
                                    {!isLoading ? (
                                        <Dropdown
                                            id="turmaId"
                                            name="turmaId"
                                            options={turma}
                                            emptyMessage="Nenhuma turma encontrada"
                                            emptyFilterMessage={"Nenhuma turma encontrada"}
                                            filter={true}
                                            value={formik.values.turmaId}
                                            className={classNames({ 'p-invalid': isFormFieldValid('turmaId') })}
                                            placeholder="Selecione uma turma"
                                            showClear={false}
                                            disabled={!!turmaIdObrigatorio}
                                            onChange={(e) => {
                                                formik.handleChange(e);
                                                carregarAlunosDaTurma(e.value, formik.values.dataOcorrencia);
                                            }}
                                        />
                                    ) : (
                                        <Skeleton height="35px" />
                                    )}
                                    {formik.errors.turmaId && formik.touched.turmaId && (
                                        <ErrorValidationMessage message={formik.errors.turmaId} />
                                    )}
                                </div>
                            ) : null}

                            <div className="p-field p-col-12 p-sm-4">
                                <label
                                    htmlFor="obs"
                                    className={classNames({ 'p-error': isFormFieldValid('obs') })}
                                >
                                    Observação
                                </label>
                                {!isLoading ? (
                                    <InputText
                                        id="obs"
                                        name="obs"
                                        className={classNames({ 'p-invalid': isFormFieldValid('obs') })}
                                        value={formik.values.obs || ""}
                                        onChange={formik.handleChange}
                                    />
                                ) : (
                                    <Skeleton height="35px" />
                                )}
                                {formik.errors.obs && formik.touched.obs && (
                                    <ErrorValidationMessage message={formik.errors.obs} />
                                )}
                            </div>

                            {isEditing && (
                                <div className="p-field p-col-12 p-sm-4">
                                    <label htmlFor="atraso">Tipo de Registro</label>
                                    {!isLoading ? (
                                        <Dropdown
                                            id="atraso"
                                            name="atraso"
                                            value={formik.values.atraso !== undefined ? formik.values.atraso : null}
                                            options={[
                                                { label: 'FALTA', value: false },
                                                { label: 'ATRASO', value: true }
                                            ]}
                                            onChange={(e) => formik.setFieldValue('atraso', e.value)}
                                            placeholder="Selecione o tipo"
                                        />
                                    ) : (
                                        <Skeleton height="35px" />
                                    )}
                                </div>
                            )}

                            <div className="p-field p-col-12 p-sm-4 p-md-4">
                                <label
                                    htmlFor="dataOcorrencia"
                                    className={classNames({ 'p-error': isFormFieldValid('dataOcorrencia') })}
                                >
                                    Data Ocorrencia
                                </label>
                                <BrCalendar
                                    id="dataOcorrencia"
                                    name="dataOcorrencia"
                                    value={formik.values.dataOcorrencia instanceof Date ? formik.values.dataOcorrencia : (formik.values.dataOcorrencia ? new Date(formik.values.dataOcorrencia + 'T03:00:00') : new Date())}
                                    onChange={formik.handleChange}
                                    placeholder={isEditing ? new Date(formik.values.dataOcorrencia + ' 03:00:00.000').toLocaleDateString('pt-BR') : ""}
                                    className={classNames({ 'p-invalid': isFormFieldValid('dataOcorrencia') })}
                                    yearRange={`2000:${new Date().getFullYear() + 1}`}
                                />
                                {formik.errors.dataOcorrencia && formik.touched.dataOcorrencia && (
                                    <ErrorValidationMessage message={formik.errors.dataOcorrencia} />
                                )}
                            </div>

                            <div className="p-d-flex p-jc-end p-mr-1">
                                {!isEditing ? (
                                    <TabelaAlunosFalta alunos={alunos} setAlunos={setAlunos} />
                                ) : null}
                            </div>
                        </div>

                        <div className="p-d-flex p-jc-end p-mr-1">
                            {!isLoading ? (
                                <Button
                                    label={isEditing ? 'Atualizar' : 'Salvar'}
                                    type="submit"
                                    iconPos="right"
                                    loading={isSubmiting}
                                />
                            ) : (
                                <Skeleton width="82.16px" height="35px" />
                            )}
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
}